module.exports = __webpack_public_path__ + "media/images/warning-box-7b40503892ea71f7250643c6c6d24cc8.svg";